module.exports = __webpack_public_path__ + "static/media/img-mygood-product-5@3x.889d30fa.png";